import "bootstrap/dist/css/bootstrap.min.css";
import './Assets/Css/datadeli-styles.css';
import "./Assets/Css/custom-styles.css";
import "./Assets/Css/group-styles.css";
import "./Assets/Css/billing.css";
import "./Assets/Css/gmr-demo.css";
import "./Assets/Css/services.css";
import "./Assets/Css/resources.css";
import "./Assets/Css/email-unsubscribe.css";
import "./Assets/Css/aoi-details-styles.css";
import "./Assets/Css/tour.css";
import "./Assets/Css/cs-cockpit.css";
import "./Assets/Css/gailpoc.css";
import "./Assets/Css/dashboard.css";
import "./Assets/Css/timeline.css";
import "./Assets/Css/home-page.css";
import "./Assets/Css/land-acquisition.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

//import "./Assets/Css/aos.css";
import {Amplify, Auth, Hub} from "aws-amplify";
import {BrowserRouter as Router, Routes, Route, Outlet} from "react-router-dom";
import {React, useEffect, useState, lazy, Suspense} from "react";
import {UserContext} from "./Contexts/UserContext";
import {memberService} from "./Services/memberService";
import {adminService} from "./Services/adminService";
import NavBar from "./Components/NavBar";
import Footer from "./Components/Footer";
import LoginModal from "./Components/LoginModal";
import EditProfileModal from "./Components/EditProfileModal";
import Snackbar from "./Components/Snackbar";
import Dashboard from "./Pages/Dashboard";
import TermsOfService from "./Pages/TermsOfService";
import PrivacyPolicy from "./Pages/PrivacyPolicy";
import { siteService } from "./Services/siteService";
import toast from 'react-hot-toast';
import UserProfile from "./Pages/UserProfile";
import Payment from "./Pages/Payment";
import { usecaseService } from "./Services/usecaseService";
import { aoiService } from "./Services/aoiService";
import { MapUtils } from "./Components/MapUtils";
import { dbService } from "./Services/dbService";
import { aoiPricingUtil } from "./Utils/aoiPricingUtil";
import { getUserPreference } from "./Components/Utils";
import PaymentSuccess from "./Pages/PaymentSuccess";
import PaymentCancel from "./Pages/PaymentCancel";
import { Buffer } from "buffer";
import Member from "./Components/UserProfile/Member";
import ImageGalleryModal from "./Components/ImageGallery/ImageGalleryModal";
import Services from "./Pages/Services";
import Resources from "./Pages/Resources";
import Unsubscribe from "./Pages/Unsubscribe";
import Contact from "./Pages/Contact";
import CustomerPayment from "./Pages/CustomerPayment";
import Help from "./Pages/Help";
import { fetchWrapper } from "./Helpers/fetchWrapper";
import * as turf from '@turf/turf';
import DashboardGail from "./Pages/DashboardGail";
import TimelineLandDef from "./Pages/TimelineLandDef";
import TimelineLeakage from "./Pages/TimelineLeakage";
import Copyright from "./Components/Copyright";
import Cookies from 'js-cookie';
import { userService } from "./Services/userService";
import Role from "./Helpers/Role";
import SelectOrgModal from "./Components/SelectOrgModal";
import { hasPermission } from "./Utils/PermissionUtils";
import { Permission } from "./Utils/Permission";
import { orgService } from "./Services/orgService";
import ManageEvents from "./Pages/ManageEvents";
import ResetPassword from "./Pages/ResetPassword";
import LayerSummary from "./Pages/LayerSummary";
import ContactUsModal from "./Components/ContactUs/ContactUsModal";
import GMRInnovexDemo from "./Pages/GMRInnovexDemo";
import ManageAOIs from "./Pages/ManageAOIs";
import Pune from "./Pages/Pune";

const Home = lazy(() => import('./Pages/Home'));
const Login = lazy(() => import('./Pages/Login'));
const Error = lazy(() => import('./Pages/Error'));
const Swagger = lazy(() => import('./Pages/Swagger'));

Amplify.configure(window.aws_exports);
const appConfig = window.config;

const unAuthUser = {
  email: null,
  mkey: null,
  isAuthenticated: false,
  profile: {
    name: null,
    communication_phone_number: null,
    communication_email: null,
    checked_terms_of_service: null,
    address: {
      address1: null,
      address2: null,
      address3: null,
      city: null,
      state: null,
      country: null,
      pin: null,
    },
  },
};

const initialFilters = { filterText: "", subscribed: "all", selectedGroup: null }

function App() {
  const [domainConfig, setDomainConfig] = useState({});
  const [user, setUser] = useState(unAuthUser);
  const [openLoginModal, setOpenLoginModal] = useState(false);
  const [openEditProfileModal, setOpenEditProfileModal] = useState(false);
  const [siteCache, setSiteCache] = useState({});
  const [redirectToPath, setRedirectToPath] = useState(null);
  const [notificationsCount, setNotificationsCount] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [openImpersonationModal, setOpenImpersonationModal] = useState(false);
  const impersonatedUserListInSession = sessionStorage.getItem("impersonatedUserList");
  const impersonatedUserObjInSession = sessionStorage.getItem("impersonatedUser");
  const [impersonatedUserList, setImpersonatedUserList] = useState(JSON.parse(impersonatedUserListInSession) ?? []);
  const [impersonatedUserObj, setImpersonatedUserObj] = useState(JSON.parse(impersonatedUserObjInSession) ?? null);
  const [counter, setCounter] = useState(0);
  const [allAOIs, setAllAOIs] = useState([]);
  const [groups, setGroups] = useState([]);
  const [originalAllAOIs, setOriginalAllAOIs] = useState([]);
  const [aoiThumbnails, setAoiThumbnails] = useState({});
  const [isAOIDataLoading, setIsAOIDataLoading] = useState(false);
  const [db, setDb] = useState(null);
  const [isAuthInProgress, setIsAuthInProgress] = useState(false);
  const [filter, setFilter] = useState(initialFilters);
  const [aoiPrices, setAoiPrices] = useState({});
  const [usecases, setUsecases] = useState([]);
  const [expensesPerMonth, setExpensesPerMonth] = useState(0);
  const [originalUserExpensesPerMonth, setOriginalUserExpensesPerMonth] = useState(0);
  const [showImageGalleryModal, setShowImageGalleryModal] = useState(false);
  const [galleryOptions, setGalleryOptions] = useState({});
  const [showTour, setShowTour] = useState(false);
  const [isLoggedInNow, setIsLoggedInNow] = useState(false);
  const [landuse, setLanduse] = useState(null);
  //const [rou50mLine, setRou50mLine] = useState(null);
  //const [rou50mGeometry, setRou50mGeometry] = useState(null);
  const [pipelineGeometry, setPipelineGeometry] = useState(null);
  const [timelineView, setTimelineView] = useState("single");
  //const [rou1kmGeometry, setRou1kmGeometry] = useState(null);
  //const [timelineEvents, setTimelineEvents] = useState({});
  //const [milestones, setMilestones] = useState([]);
  const [selectedTimelineView, setSelectedTimelineView] = useState("single");
  const [selectedOrgId, setSelectedOrgId] = useState(0);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [geoJsonTypes, setGeoJsonTypes] = useState([]);

  const [showMapMoveOptions, setShowMapMoveOptions] = useState(false);
  // 0 - Stopped , 1 - Started, 2 - Paused.
  const [mapMoveState, setMapMoveState] = useState(0);
  const [mapMovementPoints, setMapMovementPoints] = useState([]);
  const [mapMovementPointPosition, setMapMovementPointPosition] = useState(0);
  const [resetTimeline, setResetTimeline] = useState(0);
  const [showSelectOrgModal, setShowSelectOrgModal] = useState(false);
  const [contactUsModal, setContactUsModal] = useState({show: false, greetingMgs: '', page: '', element: '', message: ''});

  const USER_KEY = "081df3ef475240e1d975725850cb97d9";

  useEffect(async () => {
    dbService.initializeDB((database) => setDb(database));

    setIsAuthInProgress(true);
    let token = Cookies.get("authtoken");
    if(token == null)
      token = localStorage.getItem("authtoken");
    let expiryTime = Cookies.get("expiryTime");
    if(expiryTime == null)
      expiryTime = localStorage.getItem("expiryTime");
    let orgId = Cookies.get("selectedOrgId");
    if(orgId == null)
      orgId = localStorage.getItem("selectedOrgId");

    if(token != null && expiryTime != null) {
      window.authToken = token;
      window.expiryTime = expiryTime;
      setSelectedOrgId(orgId);
      userService.getProfile().then((result) => {
        console.log(result);
        if(orgId == null)
          orgId = result.userRoles[0].orgId;
        const selOrg = result.userRoles.find((o) => o.orgId == orgId);
        if(selOrg != null) {
          const selectedOrgSettings = {
            ...selOrg.orgSettings,
            orgId: selOrg.orgId,
            name: selOrg.orgName
          };
          setSelectedOrg(selectedOrgSettings);
        }
        setUser({
          email: result.userName,
          isAuthenticated: true,
          userSettings: result.settings ? JSON.parse(result.settings) : {},
          ...result
        });
        reloadGeoJsonTypes(orgId);
        aoiService.getAoisByOrgId(orgId).then((aois) => {
          setAllAOIs(aois);
        });
        setIsAuthInProgress(false);
      }).catch((e) => {
        console.log(e);
        console.log("User is not authenticated");
        setIsAuthInProgress(false);
      });
    } else {
      setIsAuthInProgress(false);
    }
  }, []);

  useEffect(() => {
    if (selectedOrgId > 0) {
      Cookies.remove("selectedOrgId");
      localStorage.removeItem("selectedOrgId");
      Cookies.set("selectedOrgId", selectedOrgId);
      localStorage.setItem("selectedOrgId", selectedOrgId);
      reloadAOIs();
      reloadGeoJsonTypes(selectedOrgId);
    }
  }, [selectedOrgId]);

  useEffect(() => {
    if(isAOIDataLoading == true)
      setCounter(counter+1);
  }, [isAOIDataLoading]);

  const getFirstTimeAOIs = () => {
    aoiService.getAois().then((aois) => {
      setAllAOIs(aois);
    });
  };

  const getAOIs = (mkey, region) => {
    getAOIsWithDB(db, mkey, region, domainConfig, user.userPreferences?.PaymentCurrency);
  };

  const getAOIsWithDB = (db, mkey, region, domainConfig, currency) => {
    setIsAOIDataLoading(true);
    dbService.getAOIGeometry(db, mkey, (dbaois) => {
      let extIds = dbaois.map(aoi => aoi.ext_id);
      aoiService.queryAOIs(mkey, region, extIds).then((data) => {
        let aois = data.aois ?? [];
        let groups = data.groups ?? [];
        let addDbAOIs = [];
        aois.forEach((aoi, index) => {
          aois[index].groups = groups.filter(group => group.member_aoi_ids?.some(aoiId => aoiId == aoi.member_aoi_id));  
          if(aois[index].geometry == null) {
            let dbaoi = dbaois.find(a => a.ext_id == aois[index].ext_id);
            if(dbaoi != null) {
              aois[index].geometry = dbaoi.aoi.geometry;
            }
          } else {
            addDbAOIs.push(aois[index]);
          }
        });
        setAllAOIs(aois);
        setGroups(groups);
        let toDeleteDBAOIs = dbaois.filter((dbaoi) => aois.find((aoi) => aoi.ext_id == dbaoi.ext_id) == null).map((aoi) => aoi.ext_id);
        dbService.storeAOIGeometry(db, mkey, aois);
        dbService.deleteAOIGeometry(db, toDeleteDBAOIs);
        getPricesForSubscribedAOIsWithDB(db, mkey, region, aois, usecases, (d) => {});
        if(domainConfig.isSingleUsecase == true) {
          aoiPricingUtil.getAoiPricingForGridView(db, mkey, region, aois, domainConfig.usecases, usecases, (priceData) => {
            setAoiPrices({...aoiPrices, ...priceData});
          });  
        }
      }).catch((error) => {
          console.error("Error in getting AOI Details!", error);
      });
    });
  };

  const getThumbnailUrls = (aois, mkey) => {
    dbService.getAOIThumbnails(db, mkey, (dbaois) => {
      let toDeleteDBAOIs = dbaois.filter((dbaoi) => aois?.find((aoi) => aoi.aoiId == dbaoi.aoiId) == null).map((aoi) => aoi.aoiId);
      dbService.deleteAOIThumbnails(db, toDeleteDBAOIs);
      
      if (!!aois) {
        Promise.all(aois?.map((aoi) => {
          let dbaoi = dbaois.find(a => a.aoiId == aoi.aoiId);
          if(dbaoi == null) {
            return fetchAndStoreThumbnail(db, mkey, aoi);
          } else {
            const blobUrl = window.URL.createObjectURL(dbaoi.image);
            return {aoiId: aoi.aoiId, blobUrl: blobUrl};
          }
        })).then((result) => {
          let thumbnails = {};
          result.forEach((aoi) => {
            thumbnails[aoi.aoiId] = aoi.blobUrl;
          });
          setAoiThumbnails(thumbnails);
          setIsAOIDataLoading(false);
        });
      }
    });
  };
  
  const fetchAndStoreThumbnail = (db, mkey, aoi) => {
    var url = MapUtils.getThumbnailUrl(aoi);
    return fetch(url).then((response)=>{
      return response.blob().then(blob => {
        dbService.storeAOIThumbnail(db, mkey, aoi.aoiId, blob);
        const blobUrl = window.URL.createObjectURL(blob);
        return {aoiId: aoi.aoiId, ext_id: aoi.ext_id, blobUrl: blobUrl};
      });
    });
  };
  
  const reloadAOIs = () => {
    if(selectedOrgId != null) {
      aoiService.getAoisByOrgId(selectedOrgId).then((aois) => {
        setAllAOIs(aois);
      }).catch((e) => {
        console.log(e);
      });
    }
  };

  const reloadGroups = () => {
    aoiService.getGroups(user.mkey, user.region)
      .then((data) => {
        let groups = data.groups ?? [];
        setGroups(groups);
        let aois = [...allAOIs];
        aois.forEach((aoi, index) => {
          aois[index].groups = groups.filter(group => group.member_aoi_ids?.some(aoiId => aoiId == aoi.member_aoi_id));  
        });
        setAllAOIs(aois);
      });
  };

  const reloadAOI = (aoiId) => {
    aoiService.getAoi(aoiId)
      .then((data) => {
        let changedAOIs = [...allAOIs.filter(aoi => aoi.aoiId != aoiId), data];
        fetchAndStoreThumbnail(db, user.mkey, data).then((imagedata) => {
          var thumbnails = {...aoiThumbnails};
          thumbnails[data.ext_id] = imagedata.blobUrl;
          setAoiThumbnails(thumbnails);
          setAllAOIs(changedAOIs);
          dbService.deleteAOIThumbnails(db, [aoiId]);
        });
      });
  };

  const removeAOIFromDB = (ext_id) => {
    dbService.deleteAOIGeometry(db, [ext_id]);
    dbService.deleteAOIThumbnails(db, [ext_id]);
    let changedAOIs = [...allAOIs.filter(aoi => aoi.ext_id != ext_id)];
    let thumbnails = {...aoiThumbnails};
    delete thumbnails[ext_id];
    setAoiThumbnails(thumbnails);
    setAllAOIs(changedAOIs);
  };

  const getAoiPricingForSubscriptions = (aoi, callback) => {
    aoiPricingUtil.getAoiPricingForSubscriptions(db, user.mkey, user.region, aoi, domainConfig.usecases, usecases, callback);
  };

  const getPricesForSubscribedAOIs = (mkey, region, aois, callback) => {
    getPricesForSubscribedAOIsWithDB(db, mkey, region, aois, usecases, callback);
  };

  const getPricesForSubscribedAOIsWithDB = (db, mkey, region, aois, usecases, callback) => {
    aoiPricingUtil.getPricesForSubscribedAOIs(db, mkey, region, aois, usecases, (data) => {
      const amount = getExpensesPerMonth(data);
      setExpensesPerMonth(amount);
      if(mkey == user.originalmKey) 
        setOriginalUserExpensesPerMonth(amount);
      !!callback && callback(data);
    });
  };

  const getExpensesPerMonth = (data) => {
    let amount = 0;
    Object.keys(data).map((extId) => {
        var subData = data[extId];
        if(subData != null) {
            Object.keys(subData).map((s) => {
                amount += subData[s];
            });
        }
    });
    return amount;
  };

  const populateNotifications = (mkey, region) => {
    memberService.getNotifications(mkey, region).then((data) => {
      var sortedData = data.sort((a, b) => Date.parse(new Date(b.message_timestamp)) - Date.parse(new Date(a.message_timestamp)));
      setNotifications(sortedData);
      setNotificationsCount(sortedData.length);
    }).catch((error) => {
      console.error("Error in retrieving notifications", error);
    });
  };

  const refreshNotifications = () => {
    populateNotifications(user.originalmKey, user.originalRegion);
  };

  const getConfigDetails = (region) => {
    return adminService
      .getConfig(region)
      .catch((error)=>
        console.error("Error in getting Config Details!", error)
      );
  };

  const getMemberDetails = (mkey, region) => {
    return memberService.get(mkey, region);
  };

  const reloadTokens = () => {
    memberService.getTokens(user.originalmKey, user.originalRegion).then((data) => {
      setUser({...user, tokens: data.tokens});
    });
  };

  const signOut = async () => {
    clearUserStates();
    //await Auth.signOut();
  };

  const showAlert = (message, type = null) => {
    if(type == "success")
      toast.success(message);
    else if(type == "fail")
      toast.error(message);
    else
      toast(message);
  };

  const isValidUserObj = (userObj) => {
    return userObj && userObj.mkey && userObj["auth-id"];
  }

  const addUserToImpersonatedUserList = (userObj) => {
    let userList = impersonatedUserList;
    if (userList.find(user=>user["auth-id"] == userObj["auth-id"])) {
      // If the user data already present, update it with new user Object
      userList = userList.filter(user=>user["auth-id"] != userObj["auth-id"]);
    }
    userList.push(userObj);

    // Store recent 5 Impersonated Users List in Session storage
    userList.sort((a, b) => {
      return +new Date(b.impersonatedTime) - +new Date(a.impersonatedTime);
    });
    userList = userList.slice(0, 5);

    setImpersonatedUserList(userList);
    sessionStorage.setItem("impersonatedUserList", JSON.stringify(userList));
  };

  const removeUserFromImpersonatedUserList = (authId) => {
    let userList = impersonatedUserList.filter(user=>user["auth-id"] != authId);
    setImpersonatedUserList(userList);
    sessionStorage.setItem("impersonatedUserList", JSON.stringify(userList));
  };

  const impersonateUser = async (enableImpersonate, userObj = null) => {
    setSiteCache({});
    setGroups([]);
    if (enableImpersonate) {
      if(user.mkey == user.originalmKey)
        setOriginalAllAOIs(allAOIs);
      setAllAOIs([]);
      if (isValidUserObj(userObj)) {
        userObj = {...userObj, impersonatedTime: new Date().toISOString()}
        setImpersonatedUserObj(userObj);
        // Store the impersonate User Id in session storage in order to retain the impersonation in page refresh
        sessionStorage.setItem("impersonatedUser", JSON.stringify(userObj));
        addUserToImpersonatedUserList(userObj);
        
        setUser({
          ...user, 
          mkey: userObj.mkey,
          region: userObj.region,
          isImpersonated: true,
          impersonatedUser: userObj,
          isReadOnly: !(user.isSuperAdmin || user.isCustomerService && appConfig.canCustomerServiceEditAOIs),
          canSubscribe: user.isSuperAdmin,
          userPreferences: getUserPreference(userObj.configuration)
        });
        getAOIs(userObj.mkey, userObj.region);
      }
    }
    else {
      setAllAOIs([]);
      sessionStorage.removeItem("impersonatedUser");
      setUser({
        ...user, 
        mkey: user.originalmKey,
        region: user.originalRegion,
        isImpersonated: false,
        impersonatedUser: null,
        isReadOnly: false,
        canSubscribe: true,
        userPreferences: user.originalUserPreference
      });
      getAOIs(user.originalmKey, user.originalRegion);
    }
    setCounter(counter+1);
  }

  const clearUserStates = () => {
    // sessionStorage.removeItem("impersonatedUser");
    // sessionStorage.removeItem("impersonatedUserList");
    // setImpersonatedUserList([]);
    localStorage.removeItem("authtoken");
    localStorage.removeItem("expiryTime");
    localStorage.removeItem("selectedOrgId");
    Cookies.remove("authtoken");
    Cookies.remove("expiryTime");
    Cookies.remove("selectedOrgId");
    setUser(unAuthUser);
    setAllAOIs(null);
    setGroups([]);
    setFilter(initialFilters);
    setSelectedOrgId(0);
  }

  const sendNotification = (search_criteria, subject = "", message = "", notificationType = "", statusCallback = null, successMgs = null) => {
    const notification_msg = {
      subject: subject,
      body: Buffer.from(message).toString('base64')
    }
    adminService.sendNotification(search_criteria, notification_msg, notificationType)
    .then(data => {
      toast.success(successMgs ?? "Message Sent Successfully");
      statusCallback && statusCallback(true);
    })
    .catch(error => {
      console.error("Error in Sending Notification", error);
      toast.error("Error in Sending Message");
      statusCallback && statusCallback(false);
    });
  };

  const hideTour = (always) => {
    setShowTour(false);
    if(!!always) {
      memberService.updateSetting(user.originalmKey, user.originalRegion, "user", "ShowTourOnLogin", false)
      .then((data) => {
          var preferences = getUserPreference(data);
          var updatedUser = {
              ...user, 
              userPreferences:  user.mkey == user.originalmKey ? preferences : user.userPreferences,
              originalUserPreference: preferences
          };
          setUser(updatedUser);
      })
      .catch((error) => {
          console.log(error);
      });
    }
  };

  const getImageFromDb = (url, callback) => {
    dbService.getImageFromDb(db, url, callback);
  };

  const storeImageInDb = (url, blob) => {
    dbService.storeImageInDb(db, url, blob);
  };

  // TODO: Remove hardcoding here. 
  const getPointsAsDistance = (distance) => {
    const lineGeoJson = {
        "type": "Feature",
        "properties": {},
        "geometry": {
            "type": "LineString",
            "coordinates": pipelineGeometry.coordinates[0]
        }
      };
    const points = [];
    const length = turf.length(lineGeoJson, {units: 'meters'});

    for(let i=0; i<= length; i+= distance) {
        const point = turf.along(lineGeoJson, i, {units: 'meters'});
        points.push(point);
    }
    return points;
  };

  const deleteImageCache = (pattern) => {
    dbService.deleteImages(db, pattern);
    toast.success("The requested cache would be cleared in a few seconds");
  }

  const startMapMove = (distance) => {
    setMapMovementPoints(getPointsAsDistance(parseInt(distance)));
    setMapMovementPointPosition(0);
    setMapMoveState(1);
  };

  const onOrgChange = (orgId, orgSettings) => {
    setSelectedOrgId(orgId);
    setSelectedOrg(orgSettings);
    setShowSelectOrgModal(false);
  };

  const reloadGeoJsonTypes = (orgId) => {
    if(orgId != null && orgId != 0) {
      orgService.getGeoJsonTypes(orgId).then((data) => {
        setGeoJsonTypes(data);
      }).catch((e) => {
        console.log(e);
      });  
    }
  };

  const showContactUsModal = (showModal, greetingMgs = '', page = '', element = '', message='') => {
      setContactUsModal({show: showModal, greetingMgs: greetingMgs, page: page, element: element, message: message});
  }

  const userContextValues = {
    domainConfig,
    usecases, setUsecases, landuse,
    user,
    setUser,
    signOut,
    openLoginModal: setOpenLoginModal,
    openEditProfileModal: setOpenEditProfileModal,
    showAlert,
    siteCache, setSiteCache,
    notifications,
    notificationsCount,
    refreshNotifications,
    impersonatedUserList, setImpersonatedUserList, impersonateUser,
    removeUserFromImpersonatedUserList,
    openImpersonationModal, setOpenImpersonationModal,
    reloadAOIs, reloadAOI, removeAOIFromDB, allAOIs, aoiPrices, originalAllAOIs, getThumbnailUrls,
    groups, reloadGroups, isAOIDataLoading,
    aoiThumbnails, isAuthInProgress,
    filter, setFilter, reloadTokens,
    getAoiPricingForSubscriptions, getPricesForSubscribedAOIs,
    sendNotification, expensesPerMonth, originalUserExpensesPerMonth,
    setShowImageGalleryModal, galleryOptions, setGalleryOptions, 
    showTour, hideTour, getImageFromDb, storeImageInDb,
    pipelineGeometry, setPipelineGeometry,
    mapMovementPoints, setMapMovementPoints,
    mapMovementPointPosition, setMapMovementPointPosition,
    mapMoveState, setMapMoveState,
    selectedTimelineView, setSelectedTimelineView,
    startMapMove, timelineView, setTimelineView,
    showMapMoveOptions, setShowMapMoveOptions, deleteImageCache,
    resetTimeline, setResetTimeline, USER_KEY,
    selectedOrgId, selectedOrg, geoJsonTypes, reloadGeoJsonTypes,
    showContactUsModal
  };

  return (
    <Router>
      <UserContext.Provider value={{...userContextValues}}>
        <NavBar mapMoveState={mapMoveState} startMapMove={startMapMove} changeMapMoveState={setMapMoveState} setShowSelectOrgModal={setShowSelectOrgModal}/>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route element={<><Outlet/><Footer /></>}>
              <Route path="/" element={<Home redirectToPath={redirectToPath} setRedirectToPath={setRedirectToPath} />} />
              <Route path="/contact-us" element={<Contact/>} />
              <Route path="/services" element={<Services />} />
              <Route path="/resources" element={<Resources/>} />
              <Route path="/gmr" element={user.isAuthenticated ? <GMRInnovexDemo /> : <Login />} />
              <Route path="/gmr/pune" element={user.isAuthenticated ? <Pune /> : <Login />} />
              <Route path="/help" element={user.isAuthenticated ? <Help/> : <Login />} />
              <Route path="/opt-out/:region/:code/:type" element={<Unsubscribe/>} />
              <Route path="/login" element={user.isAuthenticated ? <Home /> : <Login />} />
              <Route
                path="/profile"
                element={user.isAuthenticated ? <UserProfile section="profile" /> : <Login />}
              />
              <Route
                path="/settings"
                element={user.isAuthenticated ? <UserProfile section="settings" /> : <Login />}
              />
              <Route
                path="/manageaois"
                element={hasPermission(user, Permission.AoiUpdateInfo, selectedOrgId) ? <ManageAOIs /> : <Home />}>
                  <Route path=":aoiId" element={hasPermission(user, Permission.AoiUpdateInfo, selectedOrgId) ? <ManageAOIs /> : <Home />} />
              </Route>
              <Route
                path="/manageevents"
                element={!user.isClientUser && hasPermission(user, Permission.EventUpdate, selectedOrgId) ? <ManageEvents /> : <Home />}>
                  <Route path=":aoiId" element={!user.isClientUser && hasPermission(user, Permission.EventUpdate, selectedOrgId) ? <ManageEvents /> : <Home />}>
                    <Route path=":eventId" element={!user.isClientUser && hasPermission(user, Permission.EventUpdate, selectedOrgId) ? <ManageEvents /> : <Home />} />
                  </Route>
              </Route>
              <Route
                path="/geojsontypes"
                element={hasPermission(user, Permission.GeoJsonTypeView, selectedOrgId) ? <UserProfile section="geojsontypes" /> : <Home />}
              />
              <Route
                path="/mfa"
                element={user.isAuthenticated ? <UserProfile section="mfa" /> : <Login />}
              />
              <Route
                path="/billing"
                element={user.isAuthenticated ? <UserProfile section="billing" /> : <Login />}
              />
              <Route
                path="/subscriptions"
                element={user.isAuthenticated ? <UserProfile section="subscriptions" /> : <Login />}
              />
              <Route
                path="/help"
                element={user.isAuthenticated ? <UserProfile section="help" /> : <Login />}
              />
              <Route
                path="/clearcache"
                element={user.isAuthenticated ? <UserProfile section="clearcache" /> : <Login />}
              />
              <Route
                path="/configuration"
                element={user.isAdmin ? <UserProfile section="configuration" /> : <Home />}
              />
              <Route
                path="/domainconfig"
                element={user.isAdmin ? <UserProfile section="domainconfig" /> : <Home />}
              />
              <Route
                path="/datasource"
                element={user.isAdmin ? <UserProfile section="datasource" /> : <Home />}
              />
              <Route
                path="/landuse"
                element={user.isAdmin ? <UserProfile section="landuse" /> : <Home />}
              />
              <Route
                path="/usecase/add"
                element={user.isAdmin ? <UserProfile section="usecaseAdd" /> : <Home />}
              />
              <Route
                path="/usecase/edit/:name"
                element={user.isAdmin ? <UserProfile section="usecaseEdit" /> : <Home />}
              />
              <Route
                path="/usecase"
                element={user.isAdmin ? <UserProfile section="usecase" /> : <Home />}
              />
              <Route
                path="/roles"
                element={user.isAdmin ? <UserProfile section="roles" /> : <Home />}
              />
              <Route
                path="/addmember"
                element={Role.isAdmin(user.role) ? <UserProfile section="addmember" /> : <Home />}
              />
              <Route
                path="/members"
                element={hasPermission(user, Permission.UserView, selectedOrgId) ? <UserProfile section="members" /> : <Home />}
              />
              <Route
                path="/contacts"
                element={user.isAuthenticated ? <UserProfile section="contacts" /> : <Login />}
              />
              <Route
                path="/organization"
                element={user.isSuperUser ? <UserProfile section="organization" /> : <Home />}
              />
              <Route
                path="/send-message-admin"
                element={user.isDA || user.isCustomerService || user.isAdmin ? <UserProfile section="send-message-admin" /> : <Home />}
              />
              <Route
                path="/da-cockpit"
                element={user.isDA || user.isCustomerService || user.isAdmin ? <UserProfile section="da-cockpit" /> : <Home />}
              />
              <Route
                path="/cs-insights"
                element={user.isDA || user.isCustomerService || user.isAdmin ? <UserProfile section="cs-insights" /> : <Home />}
              />
              {appConfig.isPlatformApi && 
              <Route
                path="/swagger"
                element={user.isAuthenticated ? <Swagger /> : <Login />}
              /> }
              <Route path="/termsofservice" element={<TermsOfService/>} />
              <Route path="/privacypolicy" element={<PrivacyPolicy/>} />
              <Route path="/payment/success" element={user.isAuthenticated ? <><PaymentSuccess /></> : <><Login /><Footer/></>}>
                <Route path=":paymentId" element={user.isAuthenticated ? <><PaymentSuccess /></> : <><Login /><Footer/></>} />
              </Route>
              <Route path="/payment/cancel" element={user.isAuthenticated ? <><PaymentCancel /></> : <><Login /><Footer/></>}></Route>
              <Route path="/payment/:paramAmount" element={user.isAuthenticated ? <><Payment /></> : <><Login /><Footer/></>} />
              <Route path="/payment" element={user.isAuthenticated ? <><Payment /></> : <><Login /><Footer/></>} />
              <Route path="/customer-payment" element={user.isAuthenticated ? <><CustomerPayment /></> : <><Login /><Footer/></>} />
              <Route path="/member/:authId" element={user.isDA || user.isCustomerService || user.isAdmin ? <Member /> : <Home />} />
              <Route path="*" element={<Error />} />
            </Route> 
            <Route
              path="/portfolio"
              element={user.isAuthenticated ? <><Dashboard key={counter} /></> : <><Login /><Footer/></>}
            >
              <Route path=":dashboardView" element={user.isAuthenticated ? <><Dashboard key={counter} /></> : <><Login /><Footer/></>} >
                <Route path=":singlegroup" element={user.isAuthenticated ? <><Dashboard key={counter} /></> : <><Login /><Footer/></>}>
                  <Route path=":aoiId" element={user.isAuthenticated ? <><Dashboard key={counter} /></> : <><Login /><Footer/></>} />
                </Route>
              </Route>
            </Route>
            <Route path="/dashboard" element={user.isAuthenticated ? <LayerSummary /> : <><Login /><Footer/></>} />
            {
              usecaseService.getUsecaseRoutes(user.isAuthenticated)
            }
            <Route path="/land-deformation" element={user.isAuthenticated ? <><TimelineLandDef /><Copyright/></> : <><Login /><Footer/></>} />
            <Route path="/leakage" element={user.isAuthenticated ? <><TimelineLeakage/><Copyright/></> : <><Login /><Footer/></>} />
            <Route path="/reset-password" element={<ResetPassword />} />
          </Routes> 
        </Suspense>
        { openEditProfileModal && <EditProfileModal /> }
        { openLoginModal && <LoginModal setShowSelectOrgModal={setShowSelectOrgModal} /> }
        { showImageGalleryModal && <ImageGalleryModal setShowImageGalleryModal={setShowImageGalleryModal} galleryOptions={galleryOptions}/> }
        {
            showSelectOrgModal &&
            <SelectOrgModal 
              setShowSelectOrgModal={setShowSelectOrgModal}
              userOrgs={user?.userRoles}
              onOrgSelect={onOrgChange}
            />
        }
        {
          !!contactUsModal.show &&
          <ContactUsModal contactUsModal={contactUsModal} showContactUsModal={showContactUsModal} />
        }
        <Snackbar></Snackbar>
      </UserContext.Provider>
    </Router>
  );
}

export default App;